module.exports = __webpack_public_path__ + "img/图层 7.aaf038ec.png";